import { Link } from "react-router-dom";

export default function SiteFooter() {
  return (
    <footer className="mt-16 border-t border-background-200 bg-background-100">
      <div className="mx-auto px-4 py-10 md:px-8 md:py-14">
        <div className="flex flex-col gap-8 md:flex-row md:items-start md:justify-between">
          <div className="max-w-sm">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-950">
                <i className="ri-movie-2-fill text-xl" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-xl font-700 tracking-wide text-foreground-950">西瓜影院</span>
            </div>
            <p className="mt-4 text-sm leading-6 text-foreground-400">
              西瓜影院专注为影视爱好者提供丰富的电影与电视剧资源，涵盖最新上映及经典佳片，致力于打造便捷、高效的优质观影信息平台。
            </p>
          </div>

          <div className="flex flex-wrap gap-10 md:gap-16">
            <div>
              <h4 className="mb-3 text-sm font-700 text-foreground-950">
                <Link to="/category/movie" className="hover:text-primary-400">
                  影视分类
                </Link>
              </h4>
              <ul className="space-y-2 text-sm text-foreground-400">
                <li>
                  <Link to="/category/movie" className="transition-colors hover:text-primary-400">
                    电影
                  </Link>
                </li>
                <li>
                  <Link to="/category/tv" className="transition-colors hover:text-primary-400">
                    电视剧
                  </Link>
                </li>
                <li>
                  <Link to="/search" className="transition-colors hover:text-primary-400">
                    全站搜索
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="mb-3 text-sm font-700 text-foreground-950">
                <Link to="/about" className="hover:text-primary-400">
                  网站信息
                </Link>
              </h4>
              <ul className="space-y-2 text-sm text-foreground-400">
                <li>
                  <Link to="/about" className="transition-colors hover:text-primary-400">
                    关于我们
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="transition-colors hover:text-primary-400">
                    免责声明
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="transition-colors hover:text-primary-400">
                    使用说明
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-300 pt-6 text-xs text-foreground-500 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 西瓜影院 XIGUA CINEMA. 本站为演示站点，所有影视为虚构示例，不提供真实播放与下载服务。</p>
          <p className="flex items-center gap-2">
            <i className="ri-shield-check-line text-base" aria-hidden="true"></i>
            内容仅用于产品演示与学习
          </p>
        </div>
      </div>
    </footer>
  );
}